<template>
  <layout-page>
    <div class="card-header">
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <img src="@/assets/logo.png" width="250">
        </div>
        <div class="col-md-4 col-sm-12 p-4 text-center">
          <h3>
            <i class="bi bi-person-badge"></i>
          </h3>
          <h5>{{ nome }}</h5>
        </div>
        <div class="col-sm-12 col-md-4">
          <button @click="printComissaoReport" class="no-print btn btn-system btn-sm float-end">
            Imprimir
            <i class="bi bi-printer"></i>
          </button>
        </div>

      </div>
    </div>
    <div class="card-body">
      <div class="row ">
        <div class="col-4 no-print">
          <div class="input-control p-2">
            <label class="mx-2" for="inicio">Data Inicial</label>
            <input @change="pesquisarLucro()" v-model="data_inicio" id="inicio" type="date" class="form-control">
          </div>

        </div>
        <div class="col-4 no-print">
          <div class="input-control p-2">
            <label class="mx-2" for="inicio">Data Final</label>
            <input @change="pesquisarLucro()" v-model="data_final" id="final" type="date" class="form-control">
          </div>

        </div>
        <div class="col-12 p-5">
          <div class="row" id="comissaoReport">
            <div class="col-md-12 col-sm-12 p-5">
              <span v-if="tipoUser=='vendedor'" class="badge bg-system">Lucros do Vendedor</span>
              <span v-if="tipoUser=='revendedor'" class="badge bg-system">Lucros da Corretora</span>
              <span v-if="tipoUser=='admin'" class="badge bg-system">Lucros da Corretora</span>
              <span v-if="tipoUser=='franqueador'" class="badge bg-system">Lucros da Fraqueadora</span>
              <h1 class="comissao">R$ {{ lucroUsuario }}</h1>
              <div class="row">
                <div class="col-12">
                  <svg fill="#daa520" height="79px" width="79px" version="1.1" xmlns="http://www.w3.org/2000/svg"
                       viewBox="0 0 278 278" xmlns:xlink="http://www.w3.org/1999/xlink"
                       enable-background="new 0 0 278 278"
                       stroke="#daa520">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <g>
                        <path
                            d="m278,91.506c0-6.109-2.567-11.619-6.666-15.543 4.099-3.924 6.666-9.434 6.666-15.543 0-11.878-9.664-21.542-21.543-21.542h-100.637c-10.726,0-19.621,7.889-21.25,18.164-30.38,1.624-56.416,19.847-69.204,45.739h-43.823c-11.879,0-21.543,9.664-21.543,21.543 0,6.108 2.567,11.618 6.666,15.542-4.099,3.924-6.666,9.435-6.666,15.543 0,6.108 2.567,11.618 6.666,15.542-4.099,3.925-6.666,9.435-6.666,15.543 0,6.109 2.567,11.619 6.666,15.543-4.099,3.924-6.666,9.434-6.666,15.543 0,11.878 9.664,21.542 21.543,21.542h100.637c10.726,0 19.621-7.889 21.25-18.164 30.38-1.624 56.416-19.847 69.204-45.739h43.823c11.879,0 21.543-9.664 21.543-21.543 0-6.108-2.567-11.618-6.666-15.542 4.098-3.924 6.666-9.434 6.666-15.543 0-6.108-2.567-11.618-6.666-15.542 4.099-3.925 6.666-9.435 6.666-15.543zm-12,0c0,5.262-4.281,9.542-9.543,9.542h-44.712c-3.677-7.019-8.337-13.44-13.802-19.085h58.513c5.263,0 9.544,4.281 9.544,9.543zm0,31.085c0,5.262-4.281,9.542-9.543,9.542h-35.685c-0.551-6.615-1.888-13.006-3.92-19.085h39.605c5.262,2.84217e-14 9.543,4.281 9.543,9.543zm0,31.085c0,5.262-4.281,9.543-9.543,9.543h-39.026c1.885-6.091 3.064-12.485 3.473-19.085h35.553c5.262,0 9.543,4.281 9.543,9.542zm-143.82,73.446h-100.637c-5.262,0-9.543-4.281-9.543-9.542s4.281-9.542 9.543-9.542h73.144c10.726,6.909 23.147,11.396 36.5,12.663-1.297,3.731-4.84,6.421-9.007,6.421zm-110.18-40.628c0-5.262 4.281-9.542 9.543-9.542h44.712c3.677,7.019 8.337,13.44 13.802,19.085h-58.514c-5.262,0-9.543-4.281-9.543-9.543zm0-31.085c0-5.262 4.281-9.542 9.543-9.542h35.685c0.551,6.615 1.888,13.006 3.92,19.085h-39.605c-5.262,0-9.543-4.281-9.543-9.543zm0-31.085c0-5.262 4.281-9.543 9.543-9.543h39.026c-1.885,6.091-3.064,12.485-3.473,19.085h-35.553c-5.262,0-9.543-4.281-9.543-9.542zm127,84.758c-38.643,0-70.081-31.438-70.081-70.082s31.438-70.082 70.081-70.082 70.081,31.438 70.081,70.082-31.438,70.082-70.081,70.082zm16.82-158.204h100.637c5.262,1.42109e-14 9.543,4.281 9.543,9.542s-4.281,9.542-9.543,9.542h-73.144c-10.726-6.909-23.147-11.396-36.5-12.663 1.297-3.731 4.84-6.421 9.007-6.421z"></path>
                        <path
                            d="M198.798,139c0-32.973-26.825-59.798-59.798-59.798S79.202,106.027,79.202,139s26.825,59.798,59.798,59.798 S198.798,171.973,198.798,139z M139,186.798c-26.355,0-47.798-21.442-47.798-47.798S112.645,91.202,139,91.202 s47.798,21.442,47.798,47.798S165.355,186.798,139,186.798z"></path>
                        <path
                            d="m145,170.952v-1.876c9.6-2.094 16.478-9.127 16.478-17.718s-6.878-15.623-16.478-17.717v-12.15c2.785,1.245 4.478,3.265 4.478,5.151 0,3.313 2.687,6 6,6s6-2.687 6-6c0-8.59-6.877-15.623-16.478-17.718v-1.876c0-3.313-2.687-6-6-6s-6,2.687-6,6v1.876c-9.6,2.094-16.478,9.127-16.478,17.718s6.878,15.623 16.478,17.717v12.15c-2.785-1.245-4.478-3.265-4.478-5.151 0-3.313-2.687-6-6-6s-6,2.687-6,6c0,8.59 6.877,15.623 16.478,17.718v1.876c0,3.313 2.687,6 6,6s6-2.687 6-6zm-16.478-44.31c0-1.886 1.693-3.906 4.478-5.151v10.302c-2.785-1.245-4.478-3.266-4.478-5.151zm20.956,24.716c0,1.886-1.693,3.906-4.478,5.151v-10.302c2.785,1.245 4.478,3.266 4.478,5.151z"></path>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12 ">
              <canvas id="quantidadeVendas">

              </canvas>
            </div>
            <div class="col-md-6 col-sm-12 ">
              <canvas id="valorVendas">

              </canvas>
            </div>
          </div>


        </div>


      </div>
    </div>

  </layout-page>
</template>

<script>
import LayoutPage from "@/components/page/layoutPage.vue";
import RequestHelper from "@/services/RequestHelper";
import Helpers from "@/services/Helpers";
import Chart from 'chart.js/auto'
import Comissaos from "@/services/Comissaos";


export default {
  name: "DashBoardPage",
  components: {LayoutPage},
  data() {
    return {
      nome: '',
      lucroUsuario: 0,
      valorQuantidade: 0,
      mesQuantidadeFranquiador: 0,
      mesValorFranquiador: [],
      valorMensalFranquiador: 0,
      quantidadeTotalVendaMes: [],
      valorTotalVendaMes: [],
      tipoUser: '',
      displayFraquiador: false,
      data_inicio: '',
      data_final: '',
      yearNowGrafico:''
    }
  },
  methods: {
    async name() {
      let request = new RequestHelper();

      let resposeRequest = await request.postAuth(process.env.VUE_APP_API_HOST_NAME + '/api/auth/me', {view: true});
      let nomeCompleto = await resposeRequest.data.name;
      this.tipoUser = await resposeRequest.data.type;
      let business_id = await resposeRequest.data.business_id;
      let helper = new Helpers();
      if (helper.empty(business_id)) {
        location.href = '/business/create'
      }
      let row = await nomeCompleto.split(' ');
      let helpers = await new Helpers();
      for (let i = 0; i < 10; i++) {
        if (!helpers.empty(row[i])) {
          this.nome = row[i]
          i = 11;
        }
      }


    },
    async panelSystem() {
      let comissao = new Comissaos();
      let dataPanel = await comissao.painelSystem();
      this.lucroUsuario = new Helpers().numberFormat(dataPanel.valorMesAtual, 2, ',');
      this.quantidadeTotalVendaMes = await dataPanel.quantidadeTotalVendaMes;
      this.valorTotalVendasMes = await dataPanel.valorTotalVendasMes;
      this.gerarChartQuantidade();
      this.gerarChartValor();

    },
    gerarChartQuantidade() {
      const quantidadeVendas = document.getElementById('quantidadeVendas');
      let meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
      new Chart(quantidadeVendas, {
        type: 'line',
        data: {
          labels: meses,
          datasets: [{
            label: 'Quantidade de Vendas por Mês em ' + this.yearNowGrafico,
            data: this.quantidadeTotalVendaMes,
            borderWidth: 1
          }]
        },
        options: {
          scales: {
            y: {
              beginAtZero: true
            }
          }
        }
      });


    },
    gerarChartValor() {
      let meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
      const valorVendas = document.getElementById('valorVendas');
      new Chart(valorVendas, {
        type: 'bar',
        data: {
          display: true,
          labels: meses,
          datasets: [{
            label: 'Valor de Vendas por Mês em '+  this.yearNowGrafico,
            data: this.valorTotalVendasMes,
            borderWidth: 1
          }]
        },
        options: {
          scales: {
            y: {
              beginAtZero: true
            }
          }
        }
      });
    },
    printComissaoReport() {
      // Ocultar outros elementos que você não deseja imprimir
      let noPrint = document.querySelectorAll('.no-print');
      for (let i = 0; i < noPrint.length; i++) {
        noPrint[i].style.display = 'none';
      }
      let doc = document.querySelectorAll('.card-body');
      doc[0].style.overflow = 'hidden';

      let otherElementsToHide = document.getElementsByTagName('header');
      for (let i = 0; i < otherElementsToHide.length; i++) {
        otherElementsToHide[i].style.display = 'none';
      }

      // Imprimir a div com ID "comissaoReport"
      var comissaoReport = document.getElementById('comissaoReport');
      comissaoReport.style.display = 'block';


      // Chamar o método de impressão
      window.print();
      doc[0].style.overflow = 'scroll';
      // Restaurar a exibição dos elementos ocultos
      for (let i = 0; i < otherElementsToHide.length; i++) {
        otherElementsToHide[i].style.display = 'block';
      }
      // Restaurar a exibição dos elementos ocultos
      for (let i = 0; i < otherElementsToHide.length; i++) {
        otherElementsToHide[i].style.display = 'block';
      }
      // Restaurar a exibição dos elementos ocultos
      for (let i = 0; i < noPrint.length; i++) {
        noPrint[i].style.display = 'block';
      }

      // Restaurar a exibição da div com ID "comissaoReport"
      comissaoReport.style.display = 'block';
    },
    async pesquisarLucro() {
      if (!new Helpers().empty(this.data_inicio) && !new Helpers().empty(this.data_final)) {
        let comissao = new Comissaos();
        let comissaoUsuario = await comissao.pesquisarLucroUsuario(this.data_inicio, this.data_final);

        this.lucroUsuario = await new Helpers().numberFormat(comissaoUsuario, 2, ',');
      }
    },
    setDataInicial() {
      const hoje = new Date();
      const dia = '01';
      const mes = String(hoje.getMonth() + 1).padStart(2, '0'); // Meses começam em 0
      const ano = hoje.getFullYear();
      const dataInicial = `${ano}-${mes}-${dia}`;
      console.log(dataInicial)
      this.data_inicio = dataInicial;
    },
    setDataFinal() {
      const hoje = new Date();
      const mes = String(hoje.getMonth() + 1).padStart(2, '0'); // Meses de 0 (jan) a 11 (dez)
      const ano = hoje.getFullYear();

      // Número de dias no mês
      const diasNoMes = new Date(ano, mes + 1, 0).getDate();

      const dataFinal = `${ano}-${mes}-${diasNoMes}`;
      console.log(dataFinal)
      this.data_final = dataFinal;
    },
    yearNow(){
      const hoje = new Date();
      this.yearNowGrafico  = hoje.getFullYear();
    }

  },
  async mounted() {
    this.yearNow();
    await this.name();
    await this.panelSystem()
    this.setDataInicial();
    this.setDataFinal();
  }

}


</script>

<style scoped>
.comissao {
  font-weight: 200;
}
</style>